// removed by extract-text-webpack-plugin
module.exports = {"container":"container","sectionContainer":"sectionContainer","headerContainer":"headerContainer","header":"header","subheader":"subheader","headerClapping":"headerClapping","clappingAnimation":"clappingAnimation","infoContainer":"infoContainer","infoHeader":"infoHeader","infoList":"infoList","infoListItem":"infoListItem","link":"link","taco":"taco","tacoAnimation":"tacoAnimation","infoUrl":"infoUrl"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles.scss
 ** module id = 1
 ** module chunks = 0
 **/